<template>
    <div class="currentDay">
        <div class="head">
            <div class="time">
                <div class="startTime iconfont iconshijian">
                    <input
                        type="text"
                        v-model="startTime"
                        readonly
                        @click="startTimePicker = true"
                    >
                </div>
                <span>——</span>
                <div class="endTime iconfont iconshijian">
                    <input
                        type="text"
                        v-model="endTime"
                        readonly
                        @click="endTimePicker = true"
                    >
                </div>
            </div>
            <div class="btns">
                <template v-for="(item,index) in timeSlot">
                    <van-button
                        :key="index"
                        type="default"
                        :class="{active: timeSlotIndex == index}"
                        @click="selectTimePeriod(index, item)"
                    >
                        {{ item.name }}
                    </van-button>
                </template>
            </div>
        </div>
        <div class="statisticalData">
            <div>
                <h3>{{ totalOutputStatistics.filled_volume }}</h3>
                <p>生产方量(方)</p>
            </div>
            <div>
                <h3>{{ totalOutputStatistics.sale_volume }}</h3>
                <p>发货方量(方)</p>
            </div>
            <div>
                <h3>{{ totalOutputStatistics.overage_volume }}</h3>
                <p>盘盈方量(方)</p>
            </div>
        </div>
        <div class="bottom" v-show="productionStatisticsData.length>0">
            <h4>企业产量统计</h4>
            <div class="box-contain">
                <table class="stats-table">
                    <thead>
                        <tr>
                            <th>站点</th>
                            <th>生产方量(方)</th>
                            <th>销售方量(方)</th>
                            <th>盘盈方量(方)</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="item in productionStatisticsData" :key="item.enterprise_name">
                            <th>{{ item.enterprise_name }}</th>
                            <th>{{ item.filled_volume }}</th>
                            <th>{{ item.sale_volume }}</th>
                            <th>{{ item.overage_volume }}</th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="bottom image-table" v-if="productionStatisticsData.length>0">
            <h4>产品结构统计</h4>
            <div id="barChart"></div>
        </div>
        <div class="empty-data" v-if="!productionStatisticsData.length>0">
            暂无数据
        </div>
        <!-- 开始时间 -->
        <van-popup
            v-model="startTimePicker"
            position="bottom"
            :overlay="true"
        >
            <van-datetime-picker
                v-model="startCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="startConfirmData"
                @cancel="startTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
        <!-- 结束时间 -->
        <van-popup
            v-model="endTimePicker"
            position="bottom"
            :overlay="true"
        >
            <van-datetime-picker
                v-model="endCurrentDate"
                type="date"
                title="选择年月日"
                @confirm="endConfirmData"
                @cancel="endTimePicker = false"
            ></van-datetime-picker>
        </van-popup>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    name: 'current-day',
    components: {},
    data() {
        return {
            // 开始时间
            startTime: '',
            // 结束时间
            endTime: '',
            activeIndex: 0,
            // 开始时间弹出层
            startTimePicker: false,
            // 结束时间弹出层
            endTimePicker: false,
            // 开始时间默认日期
            startCurrentDate: new Date(),
            // 结束时间默认日期
            endCurrentDate: new Date(),
            timeSlot: [{
                name: '上一日',
                val: 1,
            }, {
                name: '本日',
                val: 2,
            }, {
                name: '本月',
                val: 3,
            }, {
                name: '上月',
                val: 4,
            }],
            // 时间段下标
            timeSlotIndex: 1,
            // 总产量统计数据
            totalOutputStatistics: {
                filled_volume: 0, // 生产方量
                sale_volume: 0, // 销售方量
                overage_volume: 0, // 盘盈方量
            },
            // 产量统计数据
            productionStatisticsData: [],
            // 结构统计数据
            structuralStatisticsData: [],
        };
    },
    props: {
        filterData: Object,
    },
    watch: {
        filterData() {
            this.getDayData();
        },
    },
    computed: {},
    created() {
        // 开始时间
        this.startTime = this.formatDate(new Date());
        // 结束时间
        this.endTime = this.formatDate(new Date());
    },
    mounted() {
        // 获取产量统计数据;
        this.getDayData();
    },
    methods: {
        // 选择时间段
        selectTimePeriod(index, data) {
            this.timeSlotIndex = index;
            if (data.val === 1) {
                // 前一天
                const day = new Date();
                day.setTime(day.getTime() - 24 * 60 * 60 * 1000);
                this.startTime = day.getFullYear() + '-' + (day.getMonth() + 1) + '-' + day.getDate();
                this.endTime = day.getFullYear() + '-' + (day.getMonth() + 1) + '-' + day.getDate();
            } else if (data.val === 2) {
                // 当天
                this.startTime = this.formatDate();
                this.endTime = this.formatDate();
            } else if (data.val === 3) {
                // 本月
                this.startTime = this.getCurrentMonth(this.formatDate()).startDateTime;
                this.endTime = this.getCurrentMonth(this.formatDate()).endDateTime;
            } else if (data.val === 4) {
                // 上月
                this.startTime = this.getLastMonth(this.formatDate()).startDateTime;
                this.endTime = this.getLastMonth(this.formatDate()).endDateTime;
            }
            // 获取产量统计数据
            this.getDayData();
        },
        // 确认选择开始时间
        startConfirmData(val) {
            this.startCurrentDate = val;// 开始时间默认日期
            this.startTime = this.formatDate(val);
            this.timeSlotIndex = null;
            this.startTimePicker = false;
            // 获取产量统计数据
            this.getDayData();
        },
        // 确认选择结束时间
        endConfirmData(val) {
            this.timeSlotIndex = null;
            this.endCurrentDate = val;// 结束时间默认日期
            this.endTimePicker = false;
            this.endTime = this.formatDate(val);
            // 获取产量统计数据
            this.getDayData();
        },
        // 获取数据
        async getDayData() {
            this.productionStatisticsData = [];
            const chartData = {
                yAxisData: [],
                productionVolume: [],
                salesVolume: [],
            };
            const reqData = {
                startDate: this.startTime,
                endDate: this.endTime,
                yun_yq_id: this.filterData.yun_yq_id,
                pian_q_id: this.filterData.pian_q_id,
                qi_y_id: this.filterData.qi_y_id,
            };
            this.$axios
                .post('/interfaceApi/report/production/productiondata/day?',
                    reqData
                )
                .then(res => {
                    this.totalOutputStatistics.filled_volume = res.filled_volume.toFixed(2);
                    this.totalOutputStatistics.sale_volume = res.sale_volume.toFixed(2);
                    this.totalOutputStatistics.overage_volume = res.overage_volume.toFixed(2);
                    this.productionStatisticsData = res.enterpriseDatas;
                    res.strengthGradeDatas.forEach(item => {
                        chartData.yAxisData.push(item.strength_grade_name);
                        chartData.productionVolume.push(item.filled_volume);
                        chartData.salesVolume.push(item.sale_volume);
                    });
                    this.$nextTick(() => {
                        this.initTransverseChart(chartData);
                    });
                });
        },

        // 时间格式处理
        formatDate(date) {
            if (date) {
                date = new Date(date);
            } else {
                date = new Date();
            }
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            let d = date.getDate();
            m = m < 10 ? '0' + m : m;
            d = d < 10 ? '0' + d : d;
            return y + '-' + m + '-' + d;
        },
        // 获取上个月时间段
        getLastMonth(value) {
            const returnData = {
                startDateTime: '',
                endDateTime: '',
            };
            if (value === '' || value === 'undefined') {
                return value;
            }
            // 获取上个月时间
            const nowdays = new Date(value);
            let year = nowdays.getFullYear();
            let month = nowdays.getMonth();
            if (month === 0) {
                month = 12;
                year = year - 1;
            }
            if (month < 10) {
                month = '0' + month;
            }
            const yDate = new Date(year, month, 0);
            returnData.startDateTime = year + '-' + month + '-01';
            returnData.endDateTime = year + '-' + month + '-' + yDate.getDate();

            return returnData;
        },

        // 获取本月时间段
        getCurrentMonth(value) {
            const returnData = {
                startDateTime: '',
                endDateTime: '',
            };
            if (value === '' || value === 'undefined') {
                return value;
            }
            const nowdays = new Date(value);
            const year = nowdays.getFullYear();
            let month = nowdays.getMonth() + 1;
            if (month === 11) {
                month = 12;
            }
            if (month < 10) {
                month = '0' + month;
            }
            const yDate = new Date(year, month, 0);
            returnData.startDateTime = year + '-' + month + '-01'; // 上个月第一天
            returnData.endDateTime = year + '-' + month + '-' + yDate.getDate(); // 上个月最后一天

            return returnData;
        },

        // 横向柱图
        initTransverseChart(chartData) {
            const myChart = this.$echarts.init(document.getElementById('barChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow',
                    },
                },
                legend: {
                    right: '50',
                    data: ['生产方量', '销售方量'],
                },
                grid: {
                    top: '50',
                    left: '50',
                    right: '20',
                    bottom: '20',
                },
                dataZoom: {
                    type: 'inside',
                    startValue: 0,
                    endValue: 8,
                    zoomLock: true,
                    orient: 'vertical',
                },
                xAxis: {
                    position: 'top',
                    type: 'value',
                    boundaryGap: [0, 0],
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 2, // 设置为 1，表示『隔一个标签显示一个标签』
                        //	margin:15,
                        textStyle: {
                            color: '#979EA7',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 10,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        // 坐标轴轴线相关设置
                        lineStyle: {
                            color: '#D8D8D8',
                        },
                    },
                    splitLine: {
                        // 坐标轴在 grid 区域中的分隔线。
                        show: false,
                    },
                },
                yAxis: {
                    type: 'category',
                    barCategoryGap: '30%',
                    data: chartData.yAxisData,
                    axisLabel: {
                        // 坐标轴刻度标签的相关设置。
                        interval: 0, // 设置为 1，表示『隔一个标签显示一个标签』
                        textStyle: {
                            color: '#979EA7',
                            fontStyle: 'normal',
                            fontFamily: '微软雅黑',
                            fontSize: 12,
                        },
                    },
                    axisTick: {
                        // 坐标轴刻度相关设置。
                        show: false,
                    },
                    axisLine: {
                        lineStyle: {
                            color: '#D8D8D8',
                        },
                    },
                },
                series: [
                    {
                        name: '生产方量',
                        type: 'bar',
                        data: chartData.productionVolume,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#F2E341' },
                                        { offset: 1, color: '#DCC129' },
                                    ]
                                ),
                                label: {
                                    show: true,
                                    position: 'right',
                                    textStyle: {
                                        color: '#DCC229',
                                        fontSize: 10,
                                    },
                                },
                            },
                        },
                    },
                    {
                        name: '销售方量',
                        type: 'bar',
                        data: chartData.salesVolume,
                        itemStyle: {
                            normal: {
                                color: new echarts.graphic.LinearGradient(
                                    0, 0, 0, 1,
                                    [
                                        { offset: 0, color: '#55A7FE' },
                                        { offset: 1, color: '#3E79C5' },
                                    ]
                                ),
                                label: {
                                    show: true,
                                    position: 'right',
                                    textStyle: {
                                        color: '#478BDB',
                                        fontSize: 10,
                                    },
                                },
                            },
                        },
                    },
                ],
            };
            myChart.setOption(option, true);
        },
    },
};
</script>

<style scoped lang="stylus">
.currentDay
    height 100%
    >div
        padding 15rpx
    .head
        border-bottom 1px solid #F0F0F0
        .time
            display flex
            height 36rpx
            border 1px solid #D7D7D7
            border-radius 4rpx
            margin-bottom 10rpx
            >div
                position relative
                overflow hidden
                padding-left 10rpx
                width calc((100% - 40rpx)/2)
                &:before
                    color #979EA7
                    font-size 16rpx
                    line-height 33rpx
                    left 20rpx
                    position absolute
                input
                    width 100%
                    height 100%
                    border none
                    text-align center
                    padding-left 20rpx
                    font-size 14rpx;
            >span
                width 40rpx
                line-height 34rpx
                text-align center
                color #979EA7
        .btns
            display flex
            .van-button
                flex 1
                width 70rpx
                height 30rpx
                line-height 28rpx
                margin 0 5rpx
                padding 0
                font-size 12rpx
                color #666666
                border 1px solid #D7D7D7
                border-radius 4rpx
                box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 0.2)
                &:first-child
                    margin-left 0
                &:last-child
                    margin-right 0
                &.active
                    background #3495FB
                    border-color #0E84FF
                    color #fff
                    box-shadow 2rpx 4rpx 8rpx rgba(84, 148, 243, 1)
    .statisticalData
        display flex
        height 73rpx
        display flex
        padding 14rpx 15rpx
        >div
            flex 1
            text-align center
            margin 0 4rpx
            &:nth-of-type(1)
                background rgba(85, 136, 241, 0.06)
                margin-left 0
                h3
                    color #5588F1
            &:nth-of-type(2)
                background rgba(33, 189, 204, 0.06)
                h3
                    color #5588F1
            &:nth-of-type(3)
                background rgba(255, 248, 243, 1)
                margin-right 0
                h3
                    color #FA8639
        h3
            font-size 16rpx
            line-height 26rpx
        p
            font-size 12rpx
            line-height 13rpx
            color #979EA7
    .bottom
        margin-top 15rpx
        padding 15rpx
        background-color #fff
        #barChart
            height 350rpx
            margin-top -20rpx;
        .box-contain
            margin-top 15rpx
            .stats-table
                th
                    margin 1rpx;
                    width: 85rpx;
                    height: 40rpx;
                    font-size: 13px;
                thead
                    background: #EBF0FC;
                    border: 1rpx solid #DEE3EF;
                    color:#333333
                tbody
                    tr
                        th:nth-child(1)
                            border: 1rpx solid #DEE3EF;
                    tr:nth-child(3n-2)
                        th
                            color #5588F1
                            background: rgba(85, 136, 241, 0.04);
                            &:nth-child(1)
                                background: #EBF0FC;
                    tr:nth-child(3n-1)
                        th
                            color #FA8436
                            background: rgba(250, 132, 54, 0.04);
                            &:nth-child(1)
                                background: #FCF2EB;
                    tr:nth-child(3n)
                        th
                            color #40C6D3
                            background: rgba(33, 189, 204, 0.04);
                            &:nth-child(1)
                                background: #DFFAFB;

    .empty-data{
        font-size 28rpx
        line-height 200rpx
        text-align center
        color #ccc
    }
</style>
